import { Button, Col } from "antd";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { ServerSideDataGrid } from "../../../../common/components/serverSideDataGrid/serverSideDataGrid";
import { Columns } from "./columns";
import K from "../../../../utilities/constants";
import { selectSelectedClientIds } from "../../../../redux/slices/globalSelectorSlice";
import { selectUserId } from "../../../../redux/slices/userSlice";
import Client from "../../../../redux/models/client";
import AgGridUtility from "../../../../utilities/agGridUtility";
import { usePageFilter } from "../../../../hooks/usePageFilters";
import { DataTableLayout } from "../../../../common/components/dataTableLayout/dataTableLayout";

export const ClientsContainer = () => {
  const history = useHistory();

  const clients = useSelector(selectSelectedClientIds);
  const userId = useSelector(selectUserId);

  const [search, setSearch] = usePageFilter("clients_search");

  const getServerSideData = useCallback(
    (options) => {
      return Client.v2.get({
        ...options,
        client: clients,
        search: search || undefined,
      });
    },
    [clients, search],
  );

  const onRowClicked = (e) => {
    history.push(`/clients/${e.data.id}?tab=overview`);
  };

  return (
    <DataTableLayout
      searchDefaultValue={search}
      onSearchChange={setSearch}
      actions={[
        {
          permissions: [K.Permissions.CreateClient],
          renderer: () => (
            <Col>
              <Link to="/clients/create">
                <Button
                  type="primary"
                  icon={<PlusOutlined style={{ fontSize: "0.8em" }} />}
                >
                  Client
                </Button>
              </Link>
            </Col>
          ),
        },
      ]}
    >
      <ServerSideDataGrid
        userId={userId}
        configKey={K.AgGridTable.Keys.ClientVisibleColumn}
        getData={getServerSideData}
        defaultColumnConfig={Columns}
        rowStyle={{ cursor: "pointer" }}
        onRowClicked={onRowClicked}
        getContextMenuItems={() => AgGridUtility.menuItemsWithExport}
      />
    </DataTableLayout>
  );
};
